export const SET_TAGS = 'SET_TAGS';
export const SET_TAGS_LOADING = 'SET_TAGS_LOADING';
